import React, { useMemo } from "react";
import "./MoreWork.css";
import RichTextContent, { CmsText } from "../../../RichTextContent/RichTextContent";
import arrow from "../../../../assets/icons/arrow.png";
import arr2 from "../../../../assets/icons/arr2.png";
import { HiOutlineBriefcase } from "react-icons/hi";
import { Link } from "react-router-dom";
import { useWorkSection } from "../../../../context/WorkPageContext";
import { getMoreWorkFromSection } from "../../../../services/contentApi";
import { resolveMediaUrl } from "../../../../utils/mediaUrl";

const MoreWork = () => {
  const { section, loading } = useWorkSection("work-projects");

  const { title, loadMoreText, projects } = useMemo(() => {
    if (section?.fields) {
      return getMoreWorkFromSection(section);
    }
    return {
      title: "More work",
      loadMoreText: "Load more",
      projects: [],
    };
  }, [section]);

  if (loading && section == null) return null;

  const hasProjects = projects.length > 0;

  return (
    <section className="morework">
      {hasProjects ? (
        <>
          <h2 className="morework__title">
            <CmsText content={title} as="span" />
          </h2>

          <div className="morework__grid">
            {projects.map((p) => (
              <Link
                key={p.slug}
                to={`/projectdetail/${p.slug}`}
                className="mw-card"
              >
                <div className="mw-card__image">
                  <img
                    src={
                      typeof p.image === "string"
                        ? resolveMediaUrl(p.image)
                        : p.image
                    }
                    alt=""
                  />
                </div>

                <div className="mw-card__content">
                  <CmsText
                    content={p.tag || "Industry"}
                    as="span"
                    className="mw-card__industry"
                  />

                  <div className="mw-card__title-row">
                    <h3>
                      <CmsText content={p.title} as="span" />
                    </h3>
                    <img src={arrow} alt="" className="mw-card__arrow" />
                  </div>

                  <RichTextContent content={p.desc} />
                </div>
              </Link>
            ))}
          </div>

          <div className="morework__button">
            <button type="button" className="buttonclip">
              <img src={arr2} alt="" />{" "}
              <CmsText content={loadMoreText} as="span" />
            </button>
          </div>
        </>
      ) : (
        <div className="morework__empty" role="status">
          <HiOutlineBriefcase className="morework__empty-icon" aria-hidden />
          <p className="morework__empty-text">Nothing to show</p>
        </div>
      )}
    </section>
  );
};

export default MoreWork;
